import React from 'react';
import MapView from './components/MapView';

function App() {
  return (
    <div className="App">
      <MapView />
    </div>
  );
}

export default App;
